// Where the API lives, derived from the page's host.
//
//   localhost            → http://localhost:4001/api (local dev backend)
//   <slug>.<platform>    → same origin /api — a Cloudflare origin rule routes
//                          /api to the backend port. A second-level api.<slug>.
//                          host would fall outside the *.<platform> certificate.
//   anything else        → api.<host>/api (custom tenant domains)
const PLATFORM_DOMAIN = (process.env.REACT_APP_PLATFORM_DOMAIN || 'learnsalsa.online').toLowerCase();

export function isPlatformHost(hostname: string): boolean {
  return hostname === PLATFORM_DOMAIN || hostname.endsWith(`.${PLATFORM_DOMAIN}`);
}

/**
 * The bare platform domain (and www) hosts the marketing landing page rather
 * than a studio. REACT_APP_LANDING=true previews it on localhost.
 */
export function isLandingHost(hostname: string): boolean {
  if (process.env.REACT_APP_LANDING === 'true') return true;
  return hostname === PLATFORM_DOMAIN || hostname === `www.${PLATFORM_DOMAIN}`;
}

/** The public demo studio, linked from the landing page. */
export const DEMO_STUDIO_URL = `https://demo.${PLATFORM_DOMAIN}`;

export function getApiBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  const { protocol, hostname, origin } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:4001/api';
  if (isPlatformHost(hostname)) return `${origin}/api`;
  return `${protocol}//api.${hostname}/api`;
}

/**
 * Local dev only: pick a tenant without a matching host (the backend ignores
 * this header in production). Set REACT_APP_TENANT_SLUG=demo in .env.local.
 */
export const tenantHeaders: Record<string, string> = process.env.REACT_APP_TENANT_SLUG
  ? { 'x-tenant-slug': process.env.REACT_APP_TENANT_SLUG }
  : {};
